// Add your custom JS here.

// Add Search Toogle functionality
const searchIcon = document.querySelector(".navbar__search-icon");
const searchIconActive = document.querySelector(".navbar__search-icon.active");

const searchBar = document.querySelector("#searchBar");
const featureMenuNav = document.querySelector("#feature_menuNavDropdown");
const navbarContainer = document.querySelector(".navbar-container");
const toggleBtn = document.querySelector(".mega-toggle-animated");

// Add background
const heroContainerDiv = document.querySelector(
  ".hero-colored-title .container"
);
const heroGutterDiv = document.querySelector(".hero-colored-title__gutter");
const heroHeaderDiv = document.querySelector(".hero-colored-title__header");
const bodyHasClass = document.body.classList.contains("single-projects");

// Megamenu
const megaMenu = document.querySelector(".mega-menu");
const megaMenuLinks = document.querySelectorAll(".mega-menu-link");

// Hero Carousel
const carouselInfoCaptionTriggers = document.querySelectorAll(
  ".info-caption__trigger"
);

// Youtube Play button
const playBtns = document.querySelectorAll(".media-caption__video .play-btn");

const teamSearchContainer = document.querySelector(
  ".team-members-grid__container"
);
// Hero featured Post container
const heroFeturedPosts = document.querySelectorAll(".hero-featured-post");

if (playBtns) {
  playBtns.forEach((playbtn) => {
    playbtn.addEventListener("click", (event) => {
      const btn = event.currentTarget;
      const iframe = btn.nextElementSibling;
      const videoWrapper = btn.parentElement;

      btn.classList.add("hide");
      videoWrapper.style.backgroundImage = "none";
      videoWrapper.classList.remove("gray-transparent");

      iframe.style.display = "block";
      iframe.src += "&autoplay=1";

      event.preventDefault();
    });
  });
}

function createMenuItem() {
  let li = document.createElement("li");
  li.innerHTML = `
    <button type="button" class="navbar__search-icon mb-lg-1 ms-lg-4 ms-xl-6 d-lg-none d-block">
				<small class="d-none">Search</small>
		</button>
    <form class="navbar__search-bar-mobile d-flex align-items-center ps-4 py-2" id="searchBar" method="get" action="${window.location.href}">
				<input class="form-control me-2" type="text" name="s" placeholder="What can we help you find?" aria-label="Search">
		</form>
  `;
  li.classList.add(
    "mega-menu-item",
    "mega-menu-item-type-post_type",
    "mega-menu-item-object-page",
    "mega-align-bottom-left",
    "mega-menu-flyout",
    "mega-hide-on-desktop"
  );
  return li;
}

megaMenu.appendChild(createMenuItem());

function setGutterHeight() {
  heroGutterDiv.style.height = heroHeaderDiv.clientHeight + "px";
}

function setGutterWidth() {
  let gutterWidth;
  gutterWidth = (document.body.clientWidth - heroContainerDiv.clientWidth) / 2;
  heroGutterDiv.style.width = gutterWidth + "px";
}

function setHeroFeaturedPostHeight() {
  heroFeturedPosts.forEach((heroFeaturedPost) => {
    const textContainer = heroFeaturedPost.querySelector(
      ".featured-post__text-container"
    );
    const imageContainer = heroFeaturedPost.querySelector(
      ".featured-post__img-container"
    );
    const heroTextContainer = heroFeaturedPost.querySelector(".hero-text");

    const textContainerHeight = parseInt(textContainer.clientHeight) + 80;
    const imageContainerHeight = parseInt(imageContainer.clientHeight);
    const heroTextContainerHeight = parseInt(heroTextContainer.clientHeight);

    if (window.innerWidth < 992) {
      heroFeaturedPost.style.height = "auto";
    } else {
      if (textContainerHeight > imageContainerHeight) {
        heroFeaturedPost.style.height =
          heroTextContainerHeight + textContainerHeight + "px";
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  searchIcon.addEventListener("click", function (e) {
    e.preventDefault();
    searchIcon.classList.toggle("active");
    searchBar.classList.toggle("active");
    featureMenuNav.classList.toggle("active");
  });

  console.log( 'loaded');

  if (carouselInfoCaptionTriggers) {

    console.log('carouselInfoCaptionTriggers' + carouselInfoCaptionTriggers);

    carouselInfoCaptionTriggers.forEach((trigger) => {
      trigger.addEventListener("click", function (event) {
        const slider = event.currentTarget.closest(".hero-carousel");
        slider.classList.toggle("info-caption-active");

        const projectslider = event.currentTarget.closest(".carousel");
        projectslider.classList.toggle("info-caption-active");
      });
    });
  }
  if (teamSearchContainer) {
    var mixer = mixitup(teamSearchContainer, {
      selectors: {
        target: ".team-members-grid__item",
      },
      animation: {
        duration: 300,
      },
    });
  }

  if (heroContainerDiv) {
    window.addEventListener("load", setGutterHeight);
    window.addEventListener("load", setGutterWidth);
    window.addEventListener("resize", setGutterHeight);
    window.addEventListener("resize", setGutterWidth);
  }

  if (heroFeturedPosts) {
    window.addEventListener("load", setHeroFeaturedPostHeight);
    window.addEventListener("resize", setHeroFeaturedPostHeight);
  }

  if (megaMenuLinks) {
    megaMenuLinks.forEach((menulink) => {
      menulink.addEventListener("click", function (event) {
        const clickedItem = event.currentTarget;
        const isDroppedDown = clickedItem.hasAttribute("aria-haspopup");

        if (isDroppedDown) {
          clickedItem.parentElement.classList.toggle("mega-toggle-active");

          event.preventDefault();
        }
      });

      const dropDownIndicator = menulink.querySelector(".mega-indicator");
      if (dropDownIndicator) {
        dropDownIndicator.addEventListener("click", function (event) {
          const clickedItem = event.currentTarget;
          clickedItem.parentElement.parentElement.classList.toggle(
            "mega-toggle-active"
          );
        });
      }
    });
  }
});
